export default __webpack_public_path__ + "static/media/994.d8932658.png";